module.exports = __webpack_public_path__ + "static/media/seguridad.b2259d1c.svg";